export default __webpack_public_path__ + "static/storre-utbud-online-4556e03aea86c015f8ff7d7c3073afe8.jpg";